import Vue from 'vue';

export const FormatDateFilter = Vue.filter('formatDate', (value: Date) => {
  if (!value) { return null; }
  return new Date(value).toLocaleString('pt-BR', { year: 'numeric', month: '2-digit', day: '2-digit' });
});
